import React from "react";
import { ImArrowUp } from "react-icons/im";
import { motion } from "framer-motion";
const GoTop = ({ navbar }) => {
  return (
    <motion.a
      href="#home"
      className={`${
        navbar && "display"
      }  z-30 bg-white text-gray-600 hover:scale-105 duration-75 invisible   fixed  ph:right-5 ph:bottom-5   right-10 bottom-10 shadow-md hover:shadow-xl  active:shadow-md   p-3 rounded-full `}
    >
      <ImArrowUp className="text-3xl ph:text-lg" />
    </motion.a>
  );
};

export default GoTop;
